<template>
    <LayoutsDefaultHeaderOmnibox />
    <LayoutsDefaultHeaderTheme />
    <LayoutsDefaultHeaderAiChat />
    <LayoutsDefaultHeaderNotifications />
    <LayoutsDefaultHeaderAccount />
</template>
